import { EVENTS } from '../../../../../../library';

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.VIEWS.APP.SETTINGS.MANAGE_USERS[event];
};

export const TRANSLATION_PATH = (route) => {
  return `views.app.manage.addUser.${route}`;
};
